export const setAlertMessage = function (code) {
   let  alertMessageArr=[
        {
            code:'66660004',
            message:'无法确认为同一人'
        },
        {
            code:'66660010',
            message:'姓名和身份证不一致，请确认'
        },                
        {
            code:'66660004',
            message:'无法确认为同一人'
        },                
        {
            code:'999999',
            message:'网络不给力，请稍后重试'
        }, 
        {
            code:'66660000',
            message:'请求参数异常'
        }, 
        {
            code:'66660003',
            message:'试用版最大刷脸次数已超'
        }, 
        {
            code:'66660005',
            message:'此证件信息不支持校验'
        }, 
        {
            code:'66660011',
            message:'未完成认证或认证结果已过期'
        }, 
        {
            code:'66660015',
            message:'姓名或身份证号格式不正确'
        }, 
        {
            code:'66660016',
            message:'视频或图片异常'
        }, 
        {
            code:'66660017',
            message:'验证次数超限'
        }, 
        {
            code:'66660018',
            message:'操作超时，请退出重试'
        }, 
        {
            code:'66660023',
            message:'请确保本人操作且正脸对框'
        }, 
        {
            code:'66660035',
            message:'未识别到人脸，请确保正脸对框且清晰完整'
        }, 
        {
            code:'66660037',
            message:'照片出现多张脸'
        }, 
        {
            code:'66660041',
            message:'脸部有遮挡或闭眼，请重试'
        }, 
        {
            code:'66660044',
            message:'应用服务版本过低，请升级'
        }, 
        {
            code:'66660046',
            message:'比对源照片无法处理'
        }, 
        {
            code:'66662001',
            message:'无此授权结果'
        }, 
        {
            code:'66665001',
            message:'请确保本人操作且正脸对框'
        }, 
        {
            code:'400101',
            message:'签名校验不通过'
        }, 
        {
            code:'400103',
            message:'IP 未加入白名单列表（请线下联系技术支持进行配置'
        }, 
        {
            code:'400506',
            message:'请求频率过高，请稍后再试'
        }, 
        {
            code:'400600',
            message:'【微信】下载视频失败，请重试'
        },
        
        {
            code:'400601',
            message:'视频或图片异常'
        },
        {
            code:'-5018',
            message:'未识别到指定动作'
        },
        {
            code:'-5023',
            message:'光线太强，请到室内识别'
        },
        {
            code:'-5008',
            message:'声音未能识别，请大声慢读一遍数字'
        },
        
        

    ]
    let alertMessage = '视频或图片异常请重试'
    alertMessageArr.forEach((item=>{
        if(code==item.code){
            alertMessage =item.message;
        }
    }))
    return alertMessage;
    
  }
